import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useFetch } from "@/lib/api";
import { PageHero } from "@/components/blocks/PageHero";
import { Reveal } from "@/components/blocks/Reveal";
import { Button } from "@/components/ui/button";
import { getIcon } from "@/lib/icons";

const Evangelism = () => {
  const { data: activities } = useFetch("/evangelism");

  return (
    <div>
      <PageHero
        overline="Our Evangelism"
        title="Setting the Nations on Fire"
        subtitle="Seven expressions of one mandate — carrying the Good News from mega crusades to a single soul."
        image="/images/headers/evangelism-header-image1.jpg"
        imageTestId="evangelism-page-header-image"
      />

      <section className="bg-white py-24 md:py-28">
        <div className="mx-auto max-w-7xl space-y-24 px-5 lg:px-8">
          {(activities || []).map((a, i) => {
            const Icon = getIcon(a.icon);
            const reverse = i % 2 === 1;
            return (
              <Reveal key={a.slug}>
                <div id={a.slug} className="grid scroll-mt-28 gap-10 lg:grid-cols-2 lg:items-center lg:gap-16">
                  <div className={reverse ? "lg:order-2" : ""}>
                    <div className="relative overflow-hidden bg-navy">
                      <img src={a.image} alt={a.title} className="w-full object-cover opacity-80" style={{ aspectRatio: "4/3" }} />
                    </div>
                  </div>
                  <div className={reverse ? "lg:order-1" : ""}>
                    <span className="flex items-center gap-3">
                      <span className="inline-flex h-11 w-11 items-center justify-center rounded-sm bg-brand-orange text-white">
                        <Icon className="h-5 w-5" />
                      </span>
                      <span className="overline text-brand-orange">Activity {String(i + 1).padStart(2, "0")}</span>
                    </span>
                    <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-navy md:text-4xl">{a.title}</h2>
                    <p className="mt-4 text-base leading-relaxed text-muted-foreground md:text-lg">{a.description}</p>
                    <Button asChild variant="outline" className="mt-7 rounded-sm border-navy font-display uppercase tracking-wide text-navy hover:bg-navy hover:text-white">
                      <Link to="/events" data-testid={`evangelism-cta-${a.slug}`}>
                        Related Events <ArrowRight className="ml-2 h-4 w-4" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Evangelism;
